// What the splash offers, decided BEFORE the tap (2026-10-13): Start AR when
// the browser can run an immersive-ar session; in Chrome without it ARCore
// (Google Play Services for AR) is missing; in any other browser the way
// forward is Chrome. Previously every case got a Start AR that failed on tap.

export type SplashMode =
  | { kind: 'start' }
  | { kind: 'install-arcore' }
  | { kind: 'open-in-chrome'; browserName: string }

/** Ordered: the first match names the browser. In-app webviews first — they
 *  carry a Chrome token too. */
const OTHER_BROWSERS: { test: RegExp; name: string }[] = [
  { test: /; wv\)|FBAN|FBAV|Instagram|musical_ly|Bytedance|Line\//, name: "this app's browser" },
  { test: /SamsungBrowser/, name: 'Samsung Internet' },
  { test: /Firefox|FxiOS/, name: 'Firefox' },
  { test: /EdgA/, name: 'Edge' },
  { test: /OPR\/|Opera/, name: 'Opera' },
]

export function resolveSplashMode({
  immersiveArSupported,
  userAgent,
}: {
  immersiveArSupported: boolean
  userAgent: string
}): SplashMode {
  if (immersiveArSupported) return { kind: 'start' }
  const other = OTHER_BROWSERS.find((b) => b.test.test(userAgent))
  if (other) return { kind: 'open-in-chrome', browserName: other.name }
  if (/Chrome\//.test(userAgent)) return { kind: 'install-arcore' }
  return { kind: 'open-in-chrome', browserName: 'this browser' }
}
